const receptionenquiries = [
    {
        "size": "",
        "style": "",
        "class": "",
        "children": [
            {
                "type": "topbar",
                "size": "12",
                "style": "",
                "class": "px-4",
                "title": 'Reception Enquiries',
            },
            {
                "type": "tabs",
                "size": "12",
                "style": "",
                "class": "px-4 pt-4",
                "children": [
                    {
                        "title": "Content",
                        "service": "pages",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": false,
                            "activeToggle": true,
                            "deleteButton": false, 
                            "addNewSuccessTitle": 'Topic Added!',
                            "addNewSuccessMessage": 'Topic Added Successfully!',
                            "addNewErrorTitle": 'Topic Creation Failed!',
                            "addNewErrorMessage": 'Please try again!',
                            "deleteSuccessTitle": 'Topic Deleted!',
                            "deleteSuccessMessage": 'Topic Deleted Successfully!',
                            "deleteErrorTitle": 'Topic Deletion Failed!',
                            "deleteErrorMessage": 'Please try again!',
                            "activeSuccessTitle": 'Topic Activated!',
                            "activeSuccessMessage": 'Topic Activated Successfully!',
                            "activeErrorTitle": 'Topic Activation Failed!',
                            "activeErrorMessage": 'Please try again!',
                            "updateSuccessTitle": 'Topic Updated!',
                            "updateSuccessMessage": 'Topic Updated Successfully!',
                            "updateErrorTitle": 'Topic Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                            "addNewModal": {
                                "title": "Add New Page",
                                "variant": "add",
                                "submit_url": "/api/categories/$currentCategoryId/pages",
                                "form": {
                                    "title": {
                                    "type": 'text',
                                    "label": 'Page Name',
                                    "placeholder": 'Enter Page Name',
                                    "required": true,
                                    "info": true,
                                    "character_count": 250,
                                    "disabled": false,
                                    "class": '',
                                    "size": "12",
                                    "style": ""
                                    },
                                    "group": {
                                        "type": 'reGroupSelect',
                                        "label": 'Group',
                                        "placeholder": 'Select Group',
                                        "load_url": '',
                                        "required": false,
                                        "info": false,
                                        "character_count": 0,
                                        "disabled": false,
                                        "class": '',
                                        "size": "12",
                                        "style": ""
                                    },
                                    // "subgroup": {
                                    //     "type": 'subgroupSelect',
                                    //     "label": 'Sub-Group',
                                    //     "placeholder": 'Select Sub-Group',
                                    //     "load_url": '',
                                    //     "required": false,
                                    //     "info": false,
                                    //     "character_count": 0,
                                    //     "disabled": false,
                                    //     "class": '',
                                    //     "size": "6",
                                    //     "style": ""
                                    // },
                                },
                                "additionalProps": {
                                    // "role": '',
                                    "group": '',
                                    "link_type":"External Link",
                                    "link_url":"",
                                    // "subgroup": '',
                                    // "locations": '',
                                    // "qualifications": '',
                                    // "availability": {
                                    //     'locations':  []
                                    // },
                                    // "gender": {
                                    //     'name':  'Male'
                                    // },
                                }
                            }
                        },
                        "children": [
                            {
                                "type": "footerTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0 d-flex",
                                "list": {
                                    "label": "Labels",
                                    "type": "list",
                                    "variant": "filtered",
                                    "filter": "reLabels",
                                    "filterOn": "group",
                                    "info": true,
                                    "size": "4",
                                    "style": "",
                                    "class": "p-0 pt-3 pr-3",
                                    "load_url": "/api/categories/$currentCategoryId/pages",
                                    "draggable": true,
                                    "children": [
                                    ]
                                },
                                "form": {
                                    "title": "Tab Two",
                                    "type": "form",
                                    "variant": "patch",
                                    "size": "8",
                                    "style": "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                    "class": "pl-4 pt-3",
                                    "form": {
                                        "title": {
                                            "type": 'text',
                                            "label": 'Label',
                                            "placeholder": 'Enter Member Name',
                                            "required": false,
                                            "info": false,
                                            "character_count": 250,
                                            "disabled": false,
                                            "class": '',
                                            "size": "6",
                                            "style": ""
                                        },
                                        // "link_type": {
                                        //     "type": 'select',
                                        //     "label": 'Link Type',
                                        //     "placeholder": 'Select Link Type',
                                        //     "required": false,
                                        //     "info": false,
                                        //     "character_count": 0,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "6",
                                        //     "style": "",
                                        //     "options": ['External Link', 'Internal Link']
                                        // },
                                        "link_url": {
                                            "type": 'text',
                                            "label": 'Link',
                                            "placeholder": 'Enter Link',
                                            "required": false,
                                            "info": false,
                                            "character_count": 0,
                                            "disabled": false,
                                            "class": '',
                                            "size": "6",
                                            "style": ""
                                        },
                                        // "role": {
                                        //     "type": 'text',
                                        //     "label": 'Role',
                                        //     "placeholder": 'Enter Role',
                                        //     "required": true,
                                        //     "info": true,
                                        //     "character_count": 250,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "12",
                                        //     "style": ""
                                        // },
                                        // "qualifications": {
                                        //     "type": 'text',
                                        //     "label": 'Qualifications',
                                        //     "placeholder": 'Enter Qualifications',
                                        //     "required": true,
                                        //     "info": true,
                                        //     "character_count": 250,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "12",
                                        //     "style": ""
                                        // },
                                        // "locations": {
                                        //     "type": 'locationMultiSelect',
                                        //     "label": 'Location(s)',
                                        //     "inside": ['additionalProp1', 'availability', 'locations'],
                                        //     "placeholder": 'Select Location',
                                        //     "load_url": '',
                                        //     "required": false,
                                        //     "info": false,
                                        //     "character_count": 0,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "6",
                                        //     "style": ""
                                        // },
                                        // "gender": {
                                        //     "type": 'radioObject',
                                        //     "label": 'Gender',
                                        //     "placeholder": 'Select Gender',
                                        //     "required": false,
                                        //     "info": true,
                                        //     "character_count": 0,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "6",
                                        //     "style": "",
                                        //     "options": [
                                        //         {
                                        //           "name": 'Male',
                                        //         },
                                        //         {
                                        //           "name": 'Female',
                                        //         }
                                        //       ]                                    
                                        // },
                                        // "group": {
                                        //     "type": 'groupSelect',
                                        //     "label": 'Group',
                                        //     "placeholder": 'Select Group',
                                        //     "inside": ['additionalProp1', 'group'],
                                        //     "load_url": '',
                                        //     "required": false,
                                        //     "info": false,
                                        //     "character_count": 0,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "6",
                                        //     "style": ""
                                        // },
                                        // "subgroup": {
                                        //     "type": 'subgroupSelect',
                                        //     "label": 'Sub-Group',
                                        //     "placeholder": 'Select Sub-Group',
                                        //     "inside": ['additionalProp1', 'subgroup'],
                                        //     "load_url": '',
                                        //     "required": false,
                                        //     "info": false,
                                        //     "character_count": 0,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "6",
                                        //     "style": ""
                                        // },
                                        // "group": {
                                        //     "type": 'select',
                                        //     "label": 'Group',
                                        //     "placeholder": 'Select Group',
                                        //     "required": false,
                                        //     "info": false,
                                        //     "character_count": 0,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "6",
                                        //     "style": "",
                                        //     "options": []
                                        // },
                                        // "subgroup": {
                                        //     "type": 'select',
                                        //     "label": 'Sub-Group',
                                        //     "placeholder": 'Select Sub-Group',
                                        //     "required": false,
                                        //     "info": false,
                                        //     "character_count": 0,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "6",
                                        //     "style": "",
                                        //     "options": []
                                        // },
                                        // "description": {
                                        //     "type": 'ckeditor',
                                        //     "label": 'Description',
                                        //     "placeholder": 'Enter Description',
                                        //     "required": false,
                                        //     "info": true,
                                        //     "character_count": 2000,
                                        //     "disabled": false,
                                        //     "class": '',
                                        //     "size": "12",
                                        //     "style": ""
                                        // },
                                    },
                                    "children": [
                                    ]
                                }
                            }
                            
                            
                        ]
                    },
                    {
                        "title": "Settings",
                        "service": "category",
                        "size": "",
                        "style": "",
                        "class": "flex",
                        "topbarControls": {
                            "addNewButton": false,
                            "activeToggle": false,
                            "deleteButton": false, 
                            "updateSuccessTitle": 'Category Updated!',
                            "updateSuccessMessage": 'Category Updated Successfully!',
                            "updateErrorTitle": 'Category Updation Failed!',
                            "updateErrorMessage": 'Please try again!',
                        },
                        "children": [
                            {
                                "type": "descriptionTab",
                                "size": "12",
                                "style": "",
                                "class": "p-0 d-flex",
                                "list": {
                                    "type": "list",
                                    "size": "4",
                                    "style": "",
                                    "class": "p-2",
                                    "empty": true,
                                    "children": [
                                    ]
                                },
                                "form": {
                                    "type": "form",
                                    "variant": "patch",
                                    "size": "8",
                                    "style": "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                                    "class": "pl-4 pt-3",
                                    "form": {
                                        "description": {
                                            "type": 'ckeditor',
                                            "label": 'Page Description',
                                            "placeholder": 'Enter Description',
                                            "required": true,
                                            "info": false,
                                            "character_count": 2000,
                                            "disabled": false,
                                            "class": '',
                                            "size": "12",
                                            "style": ""
                                        },
                                    },
                                    "children": [
                                    ]
                                }
                            },                            
                        ]
                    },

                ]
            }
        ]
    }
]

export { receptionenquiries };